import { useFeatureSurface } from '../../../FeatureSurfaceContext';
import { FEATURE_SURFACE_CONFIG } from '../../../featureSurfaceConfig';
import type { TemplateListView } from '../types';
import { SortableHeader } from './SortableHeader';
import styles from './templates-table.module.css';
import { TemplatesTableEmpty } from './TemplatesTableEmpty';
import { TemplatesTableRow } from './TemplatesTableRow';

export function TemplatesTable({ sortKey, sortDirection, toggleSort, rows }: TemplateListView) {
  const featureSurface = useFeatureSurface();
  const { showsSubTypeColumn } = FEATURE_SURFACE_CONFIG[featureSurface.feature];

  return (
    <>
      <div className="overflow-x-auto">
        <table className={styles.automationTemplatesTable}>
          <thead>
            <tr>
              <SortableHeader
                label="Name"
                columnKey="name"
                activeSortKey={sortKey}
                sortDirection={sortDirection}
                toggleSort={toggleSort}
              />
              <th>Categories</th>
              <SortableHeader
                label="Tenants using"
                columnKey="tenantsUsing"
                activeSortKey={sortKey}
                sortDirection={sortDirection}
                toggleSort={toggleSort}
              />
              <SortableHeader
                label="Status"
                columnKey="status"
                activeSortKey={sortKey}
                sortDirection={sortDirection}
                toggleSort={toggleSort}
              />
              {showsSubTypeColumn && <th>Review flow role</th>}
              <th className={styles.actionsHeader}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <TemplatesTableRow key={row.template.id} {...row} />
            ))}
          </tbody>
        </table>
      </div>

      {rows.length === 0 && <TemplatesTableEmpty />}
    </>
  );
}
